import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export type TRouterChangeOptions = Partial<{
    onStart: (next: string) => void,
    onComplete: () => void,

    /**
     * Фильтрует страницы, при переходе на которые
     * будет изменятся параметр `isLoading`. По умолчанию
     * `isLoading` изменяется для всех страниц
     */
    only: string[],
}>

export const useRouterChange = (options: TRouterChangeOptions = {}): [boolean, string] => {
    const router = useRouter();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [nextUrl, setNextUrl] = useState('');

    useEffect(() => {
        const { onStart, onComplete, only } = options;

        const onShow = (navUrl: string) => {
            setIsLoading(
                !only?.length || only.some(url => navUrl.startsWith(url)),
            );
            setNextUrl(navUrl);
            onStart && onStart(navUrl);
        };

        const onHide = () => {
            setIsLoading(false);
            onComplete && onComplete();
        };

        router.events.on('routeChangeStart', onShow);
        router.events.on('routeChangeComplete', onHide);

        return () => {
            router.events.off('routeChangeStart', onShow);
            router.events.off('routeChangeComplete', onHide);
        };

    }, [router.events]);

    return [isLoading, nextUrl];
};
